import styled from 'styled-components';

export const CloseModal = styled.div`
  position: relative;
  text-align: right;
  display: flex;
  justify-content: flex-end;

  > div {
    width: 30px;
    height: 30px;
    transition: .3s all;

    &:hover {
      -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
    transition: .3s all;
    }
  }

  img {
    max-width: 30px;
    cursor: pointer;
  }

  i {
    position: absolute;
    top: -20px;
    right: -17px;
    cursor: pointer;

    &:hover {
      color: #da9c15;
    }
  }
`;

export const Modal = styled.div`
  h3{
    @media (max-width: 480px){
      font-size: 18px;
    }
  }
`;

export const ModalContent = styled.div`
  margin: 30px 0;
  padding: 0 35px;

  h3 {
    font-size: 21px;
    font-weight: 300;
    text-align: center;
    line-height: 1.5;
  }
`;

export const ModalImage = styled.div`
  text-align: center;
`



// WEBPACK FOOTER //
// ./src/components/modal/index.js